/**
 * Classe responsável por aceitar as sugestões selecionadas.
 *
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 30/07/2013
 *
 */


Greenmile.ServiceTimeUpdates = Greenmile.ServiceTimeUpdates || {};

Greenmile.ServiceTimeUpdates.AcceptSelected = (function (params) {

    AcceptSelected.prototype = new Monet.Grid.ActionsModules.ButtonEventCheckBox();

    function AcceptSelected () {

        this.setValueBtn = function () {
            var value = Monet.I18n.getResourcesByKey("Greenmile.ServiceTimeUpdates.btnAcceptSelected");
            this.valueBtn = value;
        };

        this.actionAfterClickButton = function () {

            var rowsSelected       = [],
                rowsSelectedLength = 0,
                error              = null,
                grid               = null;

            try {

                grid = App.Forms.ServiceTimeUpdates.table;

                rowsSelected = grid.getSelectedRows();
                rowsSelectedLength = rowsSelected.length;

                if (rowsSelectedLength > 0) {

                    const confirmAcceptSelected = () => {
                        App.Objects.ServiceTimeUpdates.acceptSelected(rowsSelected);
                    };

                    new Greenmile.Components.AlertModal("Greenmile.ServiceTimeUpdates.confirmAcceptSelected",
                        null,
                        confirmAcceptSelected)
                    .show();

                } else {

                    new Greenmile.Components.AlertModal("Greenmile.actionGridButton.noItemChecked")
                        .show();
                }

            } catch (e) {

                error = new Monet.Exception.ReturnError(this,
                    "Error on action after click button on accept selected.", e);
                error.console();

            }

        };

        this.initialize = function (entity) {

            this.setEntity(entity);
            this.setSelector("#ServiceTimeUpdates .gridHeaderContainer .rightContainer");
            this.setScreenName("#ServiceTimeUpdates");
            this.setValueBtn();
            this.setId("btnAcceptSelected");
            this.setClassName("btn-secondary");
            this.setBtnSelector('#ServiceTimeUpdates #btnAcceptSelected');
            this.init();
        };

    }

    return AcceptSelected;

})();
